export default {
    common: {
        info: {
            YES: 'Yes',
            NO: 'No',
            OK: 'Ok',
            CONFIRM: 'Confirm',
            CONTINUE: 'Continue',
            CANCEL: 'Cancel',
            EXIT: 'Exit',
            EATEN_COOKIES: 'burp!',
            general: {
                NAME: '',
            },
        },
        warn: {},
        errors: {
            NO_MESSAGE_PROVIDED: 'No message provided',
            INCORRECT_ARGUMENT: 'Incorrect argument(s) provided',
            INCORRECT_USAGE: 'Incorrect usage of item',
            IO: 'Something went wrong while trying to write or read a file',
            JSON_PARSE: 'Something went wrong while trying to parse JSON data',
            PUBLISH: 'Something went wrong while trying to publish to Instagram',
            NETWORK: 'Something went wrong while trying to make a network request',
            TIME: 'Time makes no sense',
            UNSUPPORTED_OPERATION: 'Unsupported operation',
            INCOMPATIBLE: 'Environment is incompatible',
        },
        ask: {},
        routes: {
            info: {
                HOME: 'Home',
                ABOUT: 'About',
                CONTACT: 'Contact',
                PORTFOLIO: 'Portfolio',
            },
            warn: {},
            error: {},
            ask: {},
        },
    },
    core: {
        common: {
            info: {},
            warn: {},
            error: {},
            ask: {},
        },
        renderottie: {
            info: {
                FILE_PREFIX: 'The hard work of renderer #',
            },
            warn: {},
            error: {},
            ask: {},
        },
    },
    ui: {
        common: {
            info: {},
            warn: {
                NO_CALLBACK: 'No callback prop provided',
                GENERIC: 'This is awkward... If you see this, something very wrong has probably happened',
            },
            error: {},
            ask: {},
        },
        scenes: {
            common: {
                info: {},
                warn: {
                    EMPTY_SCENE: 'This is awkward... If you see this, something very wrong has probably happened',
                },
                error: {},
                ask: {},
            },
        },
        components: {
            common: {
                info: {},
                warn: {},
                error: {},
                ask: {},
            },
            terminal: {
                info: {
                    prefix: {
                        FETCH: 'FETCH',
                        INFO: 'INFO',
                        LOAD: 'LOAD',
                        WARN: 'WARN',
                        ERROR: 'ERROR',
                    },
                    INTRO: 'Try typing "?" to get more information on commands.',
                },
                warn: {},
                error: {
                    COMMAND_NOT_RECOGNIZED: '%1 is not a valid thing.',
                    FAKE: 'UncaughtException, message bubbled from %1:\n\tSyntaxError: Invalid or unexpected token\n\tat wrapSafe (internal/modules/cjs/loader.js:1116:16)',
                },
                ask: {},
            },
        },
        blocks: {
            common: {
                info: {},
                warn: {},
                error: {},
                ask: {},
            },
            image: {
                info: {},
                warn: {
                    NO_SRC: 'No src prop provided',
                },
                error: {},
                ask: {},
            },
        },
    },
    __boiler: {
        info: {},
        warn: {},
        error: {},
        ask: {},
    },
};
//# sourceMappingURL=english.js.map